import { render } from "./FormAutocomplete.vue?vue&type=template&id=0230c22b&scoped=true"
import script from "./FormAutocomplete.vue?vue&type=script&lang=js"
export * from "./FormAutocomplete.vue?vue&type=script&lang=js"

import "./FormAutocomplete.vue?vue&type=style&index=0&id=0230c22b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0230c22b"]])

export default __exports__